import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';

import { navConfigPropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';

function NavLink({ className = '', config, handleClick, showText }) {
  const { message, icon, fillIcon, isExternal, isActive, resolvedPath } = config;
  const Component = isExternal ? 'a' : Link;
  const componentProps = {
    className: withMods(className, { isActive }),
    onClick: handleClick,
    href: isExternal ? resolvedPath : undefined,
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noopener noreferrer' : undefined,
    to: isExternal ? undefined : resolvedPath,
  };

  return (
    <Component {...componentProps}>
      {icon && (
        <div className={withMods('nav__link-icon', { 'no-stroke': fillIcon })}>
          <Isvg src={icon} />
        </div>
      )}
      {showText && <Message className="nav__link-text" message={message} />}
    </Component>
  );
}

NavLink.propTypes = {
  className: PropTypes.string,
  config: navConfigPropTypes,
  handleClick: PropTypes.func,
  showText: PropTypes.bool,
};

export default NavLink;
